module.exports = __webpack_public_path__ + "static/media/Search.e60e41f2.svg";